// extracted by mini-css-extract-plugin
export default {"cls1":"r_a6MBJ0702QmjIEkVua","cls2":"wCSrBg4eEWM8TWr5q748 r_a6MBJ0702QmjIEkVua","isPhone":"nxXCy4cTAA4DJZJcHVXi"};